import styled, { css } from 'styled-components';
import { hexToRgbA } from '@/utilities/colors';

const transactionTypeTagWidth = 36;

export interface TransactionProps {
  type: string;
}

export const color = css<TransactionProps>`
  color: ${({ type, theme }) =>
    type.toLowerCase() === 'buy' ? theme.color.good : theme.color.warning};
`;

export const borderColor = css<TransactionProps>`
  border-color: ${({ type, theme }) =>
    type.toLowerCase() === 'buy'
      ? hexToRgbA(theme.color.good, 0.2)
      : hexToRgbA(theme.color.warning, 0.2)};
`;

export const TransactionType = styled('span')<TransactionProps>`
  height: ${({ theme }) => theme.x3spacePx}px;
  text-align: center;
  border: 1px solid;
  border-radius: 2px;
  width: ${transactionTypeTagWidth}px;
  display: inline-block;
  ${color}
  ${borderColor}
`;

export const TransactionValue = styled('span')<TransactionProps>`
  ${color}
  padding-left: ${({ theme }) => transactionTypeTagWidth + theme.x1spacePx}px;
  margin-top: 1px;
  display: inline-block;
`;
